export default __webpack_public_path__ + "static/media/WalkwayTCross.256.bde91689.png";